import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "click_collect",
  "use": "click_collect-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"click_collect\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h40v40H0z\" /><path stroke=\"currentColor\" d=\"M23.151 12.516A3.099 3.099 0 0020.118 10a3.099 3.099 0 00-3.026 2.5m9.921 9.5v-7.293H13.231v14.244h6.891\" /><path stroke=\"currentColor\" d=\"M27.435 23.778l-5.607.05-.05 5.607m.05-5.607l5.657 5.657\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol